<template>
  <div>
    <div id="header-wrapper">
			<div class="header">
				<h1>Modals</h1>
			</div>
		</div>
    <div id="content">
      <div class="types">
        <h2>Types</h2>
        <h3>Basic - small</h3>
        <div class="mt--text-right">
          <mt-button type="secondary-gray" @click="smallModalDemoVisible = true">Click to open small modal</mt-button>
        </div>

        <h3>Basic - medium</h3>
        <div class="mt--text-right">
          <mt-button type="secondary-gray" @click="mediumModalDemoVisible = true">Click to open medium modal</mt-button>
        </div>

        <h3>Basic - large</h3>
        <div class="mt--text-right">
          <mt-button type="secondary-gray" @click="largeModalDemoVisible = true">Click to open large modal</mt-button>
        </div>

        <h2>Style</h2>
        <h3>Colors</h3>
        <div class="left mt--bg--neutrals-light-gray-01 imgbox">
          <img :src="basic" alt="">
        </div>
        <div class="right mt-font--body10">
          <p>Border: #B2C0D0</p>
          <p>Buttons bar: #F6F7FA</p>
          <p>Text: #485464</p>
          <p>Subtle button: #485464  opacity 80%</p>
        </div>

        <h3>Sizing</h3>
        <div class="left mt--bg--neutrals-light-gray-01 imgbox">
          <img :src="small" alt="">
        </div>
        <div class="right mt-font--body10">
          <p>Corner radius: 4px</p>
          <p>Width: 400px</p>
          <p>Height: auto</p>
          <p>Maximum height: 600px</p>
          <p>border: 0.5px</p>
          <p>Font size: 28px</p>
          <p>Line height: 36px</p>
          <p>Font size(sentence): 16px</p>
          <p>Line height(sentence): 24px</p>
        </div>
        <div class="left mt--bg--neutrals-light-gray-01 imgbox">
          <img :src="medium" alt="">
        </div>
        <div class="left large mt--bg--neutrals-light-gray-01 imgbox">
          <img :src="large" alt="">
        </div>

        <h3>Position</h3>
        <div class="left large mt--bg--neutrals-light-gray-01 imgbox">
          <img :src="position" alt="">
        </div>

        <mt-modal :visible.sync="mediumModalDemoVisible" title="Title" @handleBeforeModalClose="handleBeforeModalClose" @open="openModal" :closeVisible="true" :icon="false">
          <div>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</div>
          <div slot="footer">
            <mt-button size="small" type="primary" @click="mediumModalDemoVisible = false">확인</mt-button>
            <mt-button size="small" type="subtle" @click="mediumModalDemoVisible = false">취소</mt-button>
          </div>
        </mt-modal>
        <mt-modal :visible.sync="smallModalDemoVisible" size="small" title="Title" @handleBeforeModalClose="handleBeforeModalClose" @open="openModal" :closeVisible="true" :icon="false">
          <div>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</div>
          <div slot="footer">
            <mt-button size="small" type="primary" @click="smallModalDemoVisible = false">확인</mt-button>
            <mt-button size="small" type="subtle" @click="smallModalDemoVisible = false">취소</mt-button>
          </div>
        </mt-modal>
        <mt-modal :visible.sync="largeModalDemoVisible" size="large" title="Title" @handleBeforeModalClose="handleBeforeModalClose" @open="openModal" :closeVisible="true" :icon="false">
          <div>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</div>
          <div slot="footer">
            <mt-button size="small" type="primary" @click="largeModalDemoVisible = false">확인</mt-button>
            <mt-button size="small" type="subtle" @click="largeModalDemoVisible = false">취소</mt-button>
          </div>
        </mt-modal>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'modals-page',
  data () {
    return {
      basic: require('@/assets/modals-style-basic.svg'),
      small: require('@/assets/modals-sizing-small.svg'),
      medium: require('@/assets/modals-sizing-medium.svg'),
      large: require('@/assets/modals-sizing-large.svg'),
      position: require('@/assets/modals-position.svg'),
      smallModalDemoVisible: false,
      mediumModalDemoVisible: false,
      largeModalDemoVisible: false,
    }
  },
  methods: {
    handleBeforeModalClose() {
      // method before close modal
    },
    openModal() {
      // method before open modal
    }
  }
}
</script>
<style lang="scss" scoped>
.mt-modal .footer { text-align: right; }
h3 { font-weight: normal; }
.right {
  width: 270px;
  padding: 2%;
  float: left;
  .button-wrap{
    padding-right: 20px;
  }
}
.left{
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 730px;
  float: left;
  position: relative;
  margin-bottom: 2em;
  &.imgbox {
    display: block;
    img { width: 100%; }
  }
  &.large { width: 1090px; }
}
</style>



// WEBPACK FOOTER //
// Modals.vue?706b0468